
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/profile/addresses/shipping",
      function () {
        return require("private-next-pages/[locale]/profile/addresses/shipping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/profile/addresses/shipping"])
      });
    }
  